export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-clipboard-pencil-dcda5ba54e69b66b193fc8a970cfade5.svg";